import { Button, Modal } from "../../../../../components";
import { AlarmListLayout } from "../../../../../layouts";
import Localization from "../../../../../localization";
import useViewModel from "../../../viewModel";
import { useRef } from "react";
import { Flex } from "antd";
import Edit from "./edit";

const AlarmModel = ({ onCancel = () => {}, onDone = async () => {} }) => {
  const { addAlarmModel, alarmModel, isDeviceTypeEditable, isConfigured } =
    useViewModel();
  const alarmConfigModalRef = useRef();

  const addAlarm = async (alarm) => {
    if (isDeviceTypeEditable(alarm)) {
      alarmConfigModalRef.current.open(alarm);
    } else {
      await addAlarmModel({ type: alarm.uuid });
      await onDone();
    }
  };

  return (
    <div>
      <AlarmListLayout
        value={alarmModel}
        filter={{ supported: true }}
        renderFooter={(alarm) => {
          const unchanged = alarm.uuid === alarmModel.uuid && isConfigured;
          return (
            <Flex className="m-30-t" gap={"1rem"}>
              <Button
                type="primary"
                onClick={() => (unchanged ? onDone() : addAlarm(alarm))}
                disabled={!alarm.uuid || alarm.integration === "other"}
                title={
                  unchanged
                    ? Localization.general.confirm
                    : Localization.general.continue
                }
              />
              <Button title={Localization.general.cancel} onClick={onCancel} />
            </Flex>
          );
        }}
      />
      <Modal
        ref={alarmConfigModalRef}
        title={Localization.service.edit_alarm_connection_config_modal_title}
        child={(alarm) => (
          <Edit
            alarm={alarm}
            onDone={async () => {
              alarmConfigModalRef.current.close();
              onDone();
            }}
          />
        )}
      />
    </div>
  );
};

AlarmModel.Edit = Edit;
export default AlarmModel;
